import axios from "../utils/axios";
import { apis } from "../constants/apis";
import httpService from "./httpService";
import { getStaticConfigs } from "../helpers/common";
import { LocalStorageKey } from "../constants/localStorageKeys";
import qs from "qs";

export async function approveOrder(payload: any)
{
  const { idStatus, ...newPay } = payload;
  // admin submit to provider
  return httpService.patch(
    `/vmrs/api/v1/orders/submit/approved/capella/${payload?.idStatus}`,
    newPay,
  );
}

export async function submitOrder(payload: any)
{
  // admin submit to provider
  return httpService.post(`/vmrs/api/v1/orders/submit`, payload);
}

export async function createOrder(payload: any)
{
  const staticConfigs = await getStaticConfigs();

  if (staticConfigs?.REACT_APP_AUTHENTICATION_METHOD === "OAUTH2")
  {
    const _url = staticConfigs?.REACT_APP_API_BASE_URL_CBD;
    return axios.post(`${_url}/api/v1/orders/archive`, payload);
  } else
  {
    return httpService.post(`/vmrs-flow/api/v1/order`, payload);
  }
}

export async function getPriority()
{
  return httpService.get(`${apis.order.getPriority}`);
}

export async function createTaskingOrder(payload: any)
{
  const staticConfigs = await getStaticConfigs();

  const _url = staticConfigs?.REACT_APP_API_BASE_URL_CBD;

  return axios.post(`${_url}/api/v1/orders/tasking`, payload);
}

export async function getArchiveOrderById(id?: any)
{
  return httpService.get(`${apis.order.getArchiveOrderById}/${id}`);
}

export async function getProductTypeId(payload: any)
{
  return httpService.get(`${apis.order.getProductTypeId}/${payload?.type}`);
}

export async function getDetailOrderTaskingByUer(id: string)
{
  const staticConfigs = await getStaticConfigs();

  if (staticConfigs?.REACT_APP_AUTHENTICATION_METHOD === "OAUTH2")
  {
    const _url = staticConfigs?.REACT_APP_API_BASE_URL_CBD;

    return axios.get(`${_url}/api/v1/orders/${id}`);
  } else
  {
    // return httpService.get(
    //   `${apis.orderTasking.getDetailOrderTaskingByUer}/${id}`
    // );

    const staticConfigs = JSON.parse(
      localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? "",
    );
    const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL;

    return axios.get(
      `${baseUrl}${apis.orderTasking.getDetailOrderTaskingByUer}/${id}`,
    );
  }
}

export async function getDetailOrderTaskingByAdmin(id: string)
{
  return httpService.get(
    `${apis.orderTasking.getDetailOrderTaskingByAdmin}/${id}/by-admin`,
  );
}

export async function getOrderByIdUser(id: string)
{
  const staticConfigs = await getStaticConfigs();

  if (staticConfigs?.REACT_APP_AUTHENTICATION_METHOD === "OAUTH2")
  {
    const _url = staticConfigs?.REACT_APP_API_BASE_URL_CBD;

    return axios.get(`${_url}/api/v1/orders/${id}`);
  } else return httpService.get(`${apis.order.getOrderByIdUser}/${id}`);
}

export async function getOrderByIdAdmin(id: string)
{
  return httpService.get(`${apis.order.getOrderByIdUser}/${id}/by-admin`);
}

export async function getDataDownload(
  orderId?: string,
  orderDetailId?: string,
)
{
  const staticConfigs = await getStaticConfigs();
  const _url = staticConfigs?.REACT_APP_API_BASE_URL_CBD;
  return axios.get(
    `${_url}${apis.orderTasking.getDownload}/${orderId}/orderdetail/${orderDetailId}`,
  );
}

export async function getOrderById(id: string)
{
  return httpService.get(`${apis.order.getOrderByIdAdmin}/${id}/by-admin`);
}

export async function getSegmentsByIdOrder(payload: any)
{
  return httpService.post(`${apis.order.getSegmentByIdOrder}`, payload);
}

export async function getSchemaCosmos(payload: any)
{
  return httpService.post(`${apis.order.getSchemaCosmos}`, payload);
}

export async function getProduction()
{
  return httpService.get(`${apis.order.getProduction}`);
}
export async function getProductionSpectralProcessing()
{
  return httpService.get(`${apis.order.getProductionSpectralProcessing}`);
}

export async function confirmOrderTaskingAdmin(payload: any)
{
  const { id, ...newPay } = payload;
  return httpService.put(
    `${apis.order.confirmOrderTaskingAdmin}/${payload?.id}`,
    newPay,
  );
}

export async function getMetakeys(payload: any)
{
  return httpService.get(`${apis.metaKey.default}`, payload);
}

export async function updateStatusTaskingOrder(payload: any)
{
  let newPay = { note: payload?.note };
  return httpService.put(
    `${apis.orderTasking.updateStatus}/${payload?.id}/${payload?.statusId}`,
    newPay,
  );
}

export async function approveArchiveOrder(payload: any)
{
  const { id, ...newPay } = payload;

  return httpService.put(
    `${apis.order.approveArchiveOrder}/${payload?.id}`,
    newPay,
  );
}

export async function getTaskingSchema(payload: any)
{
  return httpService.get(
    `/vmrs-flow/api/v1/schema/${payload?.idProvider}/${payload?.type}`,
  );
}

export async function updateArchiveOrder(payload: any)
{
  const { orderId, ...newPay } = payload;

  return httpService.put(`/vmrs/api/v1/orders/${payload?.orderId}`, newPay);
}

export async function updateArchiveOrderByAdmin(payload: any)
{
  const { orderId, ...newPay } = payload;

  return httpService.put(
    `/vmrs/api/v1/orders/${payload?.orderId}/by-admin`,
    newPay,
  );
}

export async function getOrderDetailByAdmin(payload: any)
{
  return httpService.get(
    `/vmrs/api/v1/orders/detail/${payload?.idDetailOrder}/by-admin`,
  );
}

export async function getOrderDetailByUser(payload: any)
{
  return httpService.get(
    `/vmrs/api/v1/orders/detail/${payload?.idDetailOrder}`,
  );
}

export async function postNotiOrder(payload: any)
{
  const { idDetailOrder, ...newPay } = payload;
  // using for delivery step
  return httpService.post(
    `/vmrs-flow/api/v1/order/oneatlas/notifications/${payload?.idDetailOrder}`,
    newPay,
  );
}

export async function sendPriceToUser(payload: any)
{
  const { idDetailOrder, ...newPay } = payload;
  // using for delivery step
  return httpService.put(
    `/vmrs/api/v1/orders/update/actual-price/${payload?.idDetailOrder}/by-admin`,
    newPay,
  );
}

export async function sendQuotationToUser(payload: any)
{
  // for admin

  const { orderId, ...newPay } = payload;

  return httpService.put(
    `/vmrs/api/v1/orders/update/actual-price/${payload?.orderId}/by-admin`,
    payload?.data,
  );
}

export async function sendToProvider(payload: any)
{
  // for admin
  // using for delivery step
  return httpService.post(`/vmrs/api/v1/orders/sent/${payload?.provider}`, {
    order_detail_id: payload?.idDetailOrder,
  });
}

export async function sendToProviderCapella(payload: any)
{
  // for admin
  // using for delivery step
  return httpService.post(
    `/vmrs/api/v1/orders/submit/approved/capella/${payload?.idStatus}`,
    {
      order_detail_id: payload?.idDetailOrder,
    },
  );
}

export async function uploadData(payload: any)
{
  // using for delivery step
  return httpService.post(`/vmrs/api/v1/access/upload`, payload?.formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    params: {
      order_detail_id: payload?.idDetailOrder,
    },
  });
}

export async function getDataUpload(payload: any)
{
  return httpService.get(
    `/vmrs/api/v1/access/download/${payload?.orderdetailId}`,
  );
}

export async function resendEmail(id: any)
{
  return httpService.get(`/vmrs/api/v1/access/send-mail-get-links/${id}`, {});
}

export async function getOrder(payload?: any)
{
  // return httpService.get(`/vmrs/api/v1/orders/by-user`, { params: payload });
  const staticConfigs = JSON.parse(
    localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? "",
  );
  const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL;
  return axios.get(`${baseUrl}/vmrs/api/v1/orders`, {
    params: payload,
    paramsSerializer: (params) =>
    {
      return qs.stringify(params, { arrayFormat: "repeat" });
    },
  });
}

export async function getSchemaOrder(payload?: any)
{
  const staticConfigs = JSON.parse(
    localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? "",
  );
  const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL;
  // return httpService.get(`/vmrs/api/v1/orders/by-user`, { params: payload });
  return axios.get(
    `${baseUrl}/vmrs/api/v1/workflows/type/${payload?.type}/provider/${payload?.provider_id}`,
  );
}

export async function updateStatusOrder(payload?: any)
{
  const staticConfigs = JSON.parse(
    localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? "",
  );
  const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL;
  return axios.put(
    `${baseUrl}/vmrs/api/v1/orders/${payload?.order_id}/status/${payload?.status_id}`,
    { notes: payload?.notes },
  );
}

export async function getUrlDownloadItemOrder(payload?: any)
{
  const staticConfigs = JSON.parse(
    localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? "",
  );
  const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL;
  return axios.get(
    `${baseUrl}/vmrs/api/v1/order-items/${payload?.order_id}/download`,
  );
}

export async function getStatusOrder()
{
  const staticConfigs = JSON.parse(
    localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? "",
  );
  const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL;
  // return httpService.get(`/vmrs/api/v1/orders/by-user`, { params: payload });
  return axios.get(`${baseUrl}/vmrs/api/v1/statuses`, { params: { is_user_status: true } });
}

export async function updateOrder(payload?: any)
{
  const staticConfigs = JSON.parse(
    localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? "",
  );
  const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL;
  const { id, ...newPay } = payload;
  // return httpService.get(`/vmrs/api/v1/orders/by-user`, { params: payload });
  return axios.patch(`${baseUrl}/vmrs/api/v1/orders/${payload?.id}`, newPay);
}

export async function getProvider(payload?: any)
{
  const staticConfigs = JSON.parse(
    localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? "",
  );
  const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL;
  // return httpService.get(`/vmrs/api/v1/providers?page=0&size=100&sort=desc`);
  return axios.get(`${baseUrl}/vmrs/api/v1/providers`);
}

export async function getSatellites(payload?: any)
{
  const staticConfigs = JSON.parse(
    localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? "",
  );
  const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL;
  const { providerCode, ...newPay } = payload;
  // return httpService.get(`/vmrs/api/v1/providers?page=0&size=100&sort=desc`);
  return axios.get(
    `${baseUrl}/vmrs/api/v1/satellites/provider/${payload?.providerCode}`,
    { params: newPay },
  );
}

export async function addOrder(payload?: any)
{
  const staticConfigs = JSON.parse(
    localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? "",
  );
  const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL;
  // return httpService.get(`/vmrs/api/v1/providers?page=0&size=100&sort=desc`);
  return axios.post(`${baseUrl}/vmrs/api/v1/orders`, payload);
}


export async function getGeneralFormOrderArchive()
{
  const staticConfigs = JSON.parse(
    localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? "",
  );
  const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL;
  return axios.get(
    `${baseUrl}/vmrs/api/v1/form-configs/key/general_order_form`,
  );
}


export async function getFormOrderArchiveByProviderCode(payload?: any)
{
  const staticConfigs = JSON.parse(
    localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? "",
  );
  const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL;
  return axios.get(
    `${baseUrl}/vmrs/api/v1/workflows/type/order_archive/provider/${payload?.providerCode}`,
  );
}